import { render, staticRenderFns } from "./NavigationLocalization.vue?vue&type=template&id=3acb3948&scoped=true&"
import script from "./NavigationLocalization.vue?vue&type=script&lang=js&"
export * from "./NavigationLocalization.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLocalization.vue?vue&type=style&index=0&id=3acb3948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb3948",
  null
  
)

export default component.exports